<template>
  <div class="widget-card">
    <v-card class="widget-card__card" height="100%">
      <v-card-title class="primary white--text widget-card__card-title">
        Налоговая анкета
      </v-card-title>
      <v-card-text class="block-chip widget-card__card-text pt-3">
        <div>Статус:
          <v-chip v-if="account" :class="`border-color-${account.status} sale-status`">
            {{account.status_label}}
            <span :class="`bg-color-${account.status} status-point`"></span>
          </v-chip>
          <v-chip v-else class="border-color-red sale-status">
            не заполнена
            <span class="bg-color-red status-point"></span>
          </v-chip>
        </div>
      </v-card-text>
      <v-card-actions
        class="pa-3 widget-card__card-actions"
        v-show="!account || account.status !== 'approved'"
      >
        <v-btn block color="default" to="/passport" class="widget-card__actions-btn">
          <v-icon>mdi-playlist-edit</v-icon>
          <span class="pl-4">Заполнить анкету</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default { props: ['account'] };
</script>

<style lang="scss"></style>
